<template>
  <div class="w-100" ref="root">
    <div class="card shadow overflow-hidden border-top-0 rounded-top-0 p-0 mx-0" :class="{ hide: submitted === true }">
      <form class="w-100" method="post" novalidate="true" @submit.prevent>
        <div class="card-body px-4 py-4">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-4">
                <label class="font-PM text-gray mb-3">Barrio</label>
                <div
                  class="wrapper-select-search w-100 d-flex justify-content-between align-items-center ico-blue ico-arrow-down font-AR">
                  <div class="ln-multiselect dropdown w-100">
                    <button
                      class="btn btn-secondary font-AR tracking-normal dropdown-toggle w-100 text-left pl-3 rounded-lg"
                      type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                      @click="dropdownOpen = !dropdownOpen" aria-expanded="false">
                      {{ selectedBarrio || 'Buscar barrio' }}
                    </button>
                    <div class="dropdown-menu w-100 rounded-lg mt-0"
                      :class="{ 'smallerHeight': searchBarriosError, show: dropdownOpen }"
                      aria-labelledby="dropdownMenuButton">
                      <input type="text" v-model="searchTerm" placeholder="Filtrar"
                        class="form-control search-filter mx-auto mb-2 font-AR">
                      <a class="dropdown-item full-width-item d-flex align-items-center" href="#"
                        v-for="(option, index) in filteredBarrios" :key="index" @click.prevent="selectBarrio(option)">
                        {{ option.Barrio }}
                      </a>
                      <p v-if="searchBarriosError" class="dropdown-item">Sin resultados</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-4">
                <label class="font-PM text-gray mb-3">Ambientes</label>
                <div
                  class="wrapper-select-search w-100 d-flex justify-content-between align-items-center ico-blue ico-arrow-down font-AR">
                  <div class="ln-multiselect dropdown w-100">
                    <button
                      class="btn btn-secondary font-AR tracking-normal dropdown-toggle w-100 text-left pl-3 rounded-lg"
                      type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                      @click="dropdownAmbOpen = !dropdownAmbOpen" aria-expanded="false">
                      {{ selectedAmbiente || 'Cantidad de ambientes' }}
                    </button>
                    <div class="dropdown-menu w-100 rounded-lg"
                      :class="{ 'smallerHeight': searchAmbientesError, show: dropdownAmbOpen }"
                      aria-labelledby="dropdownMenuButton">
                      <input type="text" v-model="searchAmbTerm" placeholder="Filtrar"
                        class="form-control search-filter mx-auto mb-2 font-AR">
                      <a class="dropdown-item full-width-item d-flex align-items-center" href="#"
                        v-for="(option, index) in filteredAmbientes" :key="index"
                        @click.prevent="selectAmbiente(option)">
                        {{ option.name }}
                      </a>
                      <p v-if="searchAmbientesError" class="dropdown-item">Sin resultados</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer bg-transparent border-0 px-4 pt-2 pt-md-4 pb-0">
          <div class="row justify-content-center align-items-center">
            <div class="col-md-12">
              <div class="row no-gutters justify-content-center align-items-center">
                <button type="submit" @click="submit()" :disabled="submitDisabled"
                  class="btn btn-outline-primary rounded-pill cta-start mb-4 text-uppercase font-ARB btn-square">
                  Ver resultado
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!--resultado-->
    <div class="col-lg-12 resultados" v-if="submitted">
      <div class="row">
        <div class="col-md-12 card rounded-top-0 shadow border-top-0 overflow-hidden mx-0 py-3 mb-0">
          <div class="row no-gutters justify-content-center align-items-center bg-primary rounded py-5">
            <div class="col-md-11 text-center py-4 py-xl-5">
              <div class="result" v-if="result !== ''">
                <h3 class="font-PB text-white">Alquilar {{ form.ambiente.name }} en {{ form.searchBarrio.Barrio }}:</h3>
                <div class="element-form-ico w-100 d-flex justify-content-center align-items-center text-white mb-3">
                  <h2 class="font-PB text-nowrap text-center mb-0">$ <span id="cont-resultado">{{
                    formatCustomDecimal(result) }}</span></h2>
                </div>
              </div>
              <div class="result" v-if="result === ''">
                <h4 class="font-PB text-white mb-3">Tu búsqueda no ha dado resultados.</h4>
              </div>
              <div>
                <button type="button" @click="reset()"
                  class="btn btn-secondary rounded-pill text-uppercase font-ARB btn-square">Volver a calcular</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--fin resultado-->
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount, configureCompat } from 'vue';
import numeral from 'numeral';

configureCompat({
  RENDER_FUNCTION: false,
  WATCH_ARRAY: false,
  ATTR_ENUMERATED_COERCION: false,
  CONFIG_WHITESPACE: true,
  COMPONENT_V_MODEL: false,
});

export default {
  props: ['barrios'],
  setup(props) {
    const root = ref(null);
    const searchTerm = ref('');
    const searchAmbTerm = ref('');
    const dropdownOpen = ref(false);
    const dropdownAmbOpen = ref(false);
    const result = ref(null);
    const submitted = ref(false);
    const selectedBarrio = ref(null);
    const selectedAmbiente = ref(null);
    const form = ref({
      searchBarrio: null,
      ambiente: null,
    });
    const ambientes = ref([
      { id: 'Monoambiente', name: 'Monoambiente' },
      { id: 'Amb2', name: '2 ambientes' },
      { id: 'Amb3', name: '3 ambientes' },
      { id: 'Amb4', name: '4 ambientes' },
      { id: 'Amb5', name: '5 ambientes' },
    ]);

    const closeDropdown = (event) => {
      if (!root.value.contains(event.target)) {
        dropdownOpen.value = false;
        form.searchTerm = ""
      }
    };

    const closeAmbDropdown = (event) => {
      if (!root.value.contains(event.target)) {
        dropdownAmbOpen.value = false;
        form.searchAmbTerm = ""
      }
    };

    onMounted(() => {
      document.addEventListener('click', closeDropdown);
      document.addEventListener('touchstart', closeDropdown);
      document.addEventListener('click', closeAmbDropdown);
      document.addEventListener('touchstart', closeAmbDropdown);
    });

    onBeforeUnmount(() => {
      document.removeEventListener('click', closeAmbDropdown);
      document.removeEventListener('touchstart', closeAmbDropdown);
    });

    const submitDisabled = computed(() => !form.value.searchBarrio || !form.value.ambiente);

    const filteredBarrios = computed(() => {
      if (!searchTerm.value) {
        return props.barrios;
      }
      return props.barrios.filter(barrio => barrio.Barrio.toLowerCase().includes(searchTerm.value.toLowerCase()));
    });

    const filteredAmbientes = computed(() => {
      if (!searchAmbTerm.value) {
        return ambientes.value;
      }
      return ambientes.value.filter(ambiente => ambiente.name.toLowerCase().includes(searchAmbTerm.value.toLowerCase()));
    });

    const searchBarriosError = computed(() => filteredBarrios.value.length === 0);

    const searchAmbientesError = computed(() => filteredAmbientes.value.length === 0);

    const selectBarrio = (option) => {
      selectedBarrio.value = option.Barrio;
      form.value.searchBarrio = option;
      dropdownOpen.value = false;
    };

    const selectAmbiente = (option) => {
      selectedAmbiente.value = option.name;
      form.value.ambiente = option;
      dropdownAmbOpen.value = false;
    };

    const formatCustomDecimal = (value) => {
      let parsed = parseFloat(value).toFixed(2);
      let n1 = parsed.split('.');
      if (n1[1] == '00') {
        return numeral(parseInt(n1[0])).format('0,000');
      }
      return numeral(parseFloat(parsed)).format('0,0.00');
    };

    const submit = () => {
      if (!submitDisabled.value) {
        submitted.value = true;
        let amb = form.value.ambiente.id;
        result.value = form.value.searchBarrio[amb];
      }
    };

    const reset = () => {
      submitted.value = false;
      result.value = null;
      form.value.searchBarrio = null;
      form.value.ambiente = null;
      selectedBarrio.value = null;
      selectedAmbiente.value = null;
    };

    return {
      root,
      searchTerm,
      searchAmbTerm,
      dropdownOpen,
      dropdownAmbOpen,
      result,
      submitted,
      selectedBarrio,
      selectedAmbiente,
      form,
      ambientes,
      submitDisabled,
      filteredBarrios,
      filteredAmbientes,
      searchBarriosError,
      searchAmbientesError,
      selectBarrio,
      selectAmbiente,
      formatCustomDecimal,
      submit,
      reset
    };
  },
};
</script>

<style lang="scss">
a {
  cursor: pointer;
}

ul.multiselect__content {
  max-height: 120px;
}
</style>
